import { Component } from "react";
import DataContainer from "components/utility/data-container/DataContainer";
import LegacyStrategiesViz from "./LegacyStrategiesViz";

class LegacyStrategies extends Component {
	render() {
		return (
			<DataContainer data={`legacyStrategies_${this.props.dataset.guid}`}>
				<LegacyStrategiesViz />
			</DataContainer>
		);
	}
}

export default LegacyStrategies;
